export default __webpack_public_path__ + "static/media/NPRechner.75f388cf.jpg";